/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_ButtonInputs */

const en_apply_button = /** @type {(inputs: Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_apply_button = /** @type {(inputs: Apply_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerben`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Apply_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const apply_button = /** @type {((inputs?: Apply_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_apply_button(inputs)
	return en_apply_button(inputs)
});